export const getLocalStorage = (key) => {
  let item = localStorage.getItem(key);
  try {
    item = JSON.parse(item);
  } catch (e) {}

  return item;
};

export const setLocalStorage = (key, value) => {
  let data = JSON.stringify(value);
  localStorage.setItem(key, data);
};

export const deleteLocalStorage = (key) => {
  localStorage.removeItem(key);
};

export const getSessionStorage = (key) => {
  let item = sessionStorage.getItem(key);
  try {
    item = JSON.parse(item);
  } catch (e) {
    console.log("issue getSessionStorage");
    console.log(e);
  }

  return item;
};

export const setSessionStorage = (key, value) => {
  let data = JSON.stringify(value);
  sessionStorage.setItem(key, data);
};

export const deleteSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

export function getFilePathFromUrl(url) {
  const baseUrl = `https://firebasestorage.googleapis.com/v0/b/${process.env.NEXT_PUBLIC_FBASE_BUCKET}/o/`;
  if (url.startsWith(baseUrl)) {
    const path = url.substring(baseUrl.length, url.indexOf("?"));
    return decodeURIComponent(path);
  }
  throw new Error("Invalid URL");
}
